import axios from 'axios';
import VuexStore from '../store/index';

const apiClient = new axios.create({
    baseURL: '/api/v2',
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

// catch 401 Unauthorized errors and logout the user
apiClient.interceptors.response.use(
    response => response,
    error => {
        // if unauthorized
        if (error.response.status === 401) {
            console.log('Intercepted "401 Unauthorized" response, logging out frontend...');
            VuexStore.dispatch('quickscanLogout');
        }
        return Promise.reject(error);
    }
);

export default {
    setToken(token) {
        apiClient.defaults.headers.Authentication = 'Bearer ' + token;
    },
    quickscanLogin() {
        return apiClient.post('/quickscan/login');
    },
    quickscanLogout() {
        return apiClient.post('/quickscan/logout');
    },
    quickscanStep1Load() {
        return apiClient.get('/quickscan/step1');
    },
    quickscanStep1Submit(payload) {
        return apiClient.put('/quickscan/step1', payload);
    },
    quickscanStep2Load() {
        return apiClient.get('/quickscan/step2');
    },
    quickscanStep2Submit(payload) {
        return apiClient.put('/quickscan/step2', payload);
    },
    quickscanStep3Load() {
        return apiClient.get('/quickscan/step3');
    },
    quickscanStep3Submit(payload) {
        return apiClient.put('/quickscan/step3', payload);
    },
    quickscanFinishLoad() {
        return apiClient.get('/quickscan/finish');
    },
    quickscanFinishSubmit(payload) {
        return apiClient.put('/quickscan/finish', payload);
    },
};
